import React from 'react'

import { withActions } from '../../WithActions';
import MediaRecordingActions from "../../actions/MediaRecordingActions";

import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Popover from '@material-ui/core/Popover';
import MicIcon from '@material-ui/icons/Mic';
import MicOffIcon from '@material-ui/icons/MicOff';
import VideocamIcon from '@material-ui/icons/Videocam';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const styles = (theme: Theme) => ({
  listItemRoot: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px'
  },
  typography: {
    padding: theme.spacing(2),
  }
});

const optionsSound = [
  'Mic On',
  'Mic Off'
];

const optionsCam = [
  'Camera On',
  'Camera Off'
];

interface Props {
  actions: MediaRecordingActions;
  handleMuteAudio: () => void
  handleUnMuteAudio: () => void
  setSelectedCamMenuItem: number | string
  handleChangeSourceSelected: (index: number) => void,
  handleChangeAudioAllowed: (value: boolean) => void,
  handleChangeVideoAllowed: (value: boolean) => void,
}

interface State {
  soundMenuAnchor: HTMLElement | null;  
  camMenuAnchor: HTMLElement | null;
  allowMicrophoneButtonEl: HTMLElement | null;
  allowCamButtonEl: HTMLElement | null;
  selectedSoundMenuIndex: number;
  selectedCamMenuIndex: number | any;
  audioAllowed: boolean;
  camAllowed: boolean
}

type PropsWithStyles = Props & WithStyles<'listItemRoot' | 'typography'>;

class Devices extends React.Component<PropsWithStyles, State> {

  private audioStream?: MediaStream | null;  
  private videoStream?: MediaStream | null;  

  constructor(props: PropsWithStyles) {
    super(props);
 
    this.state = {
      soundMenuAnchor: null,
      camMenuAnchor: null,
      allowMicrophoneButtonEl: null,
      allowCamButtonEl: null,
      selectedSoundMenuIndex: 0,
      selectedCamMenuIndex: props.setSelectedCamMenuItem === 'cam' || props.setSelectedCamMenuItem === 'screenCam'  ? 0 : props.setSelectedCamMenuItem,
      audioAllowed: false,
      camAllowed: false
    };
  }   

  async componentDidMount() {

    try {
      const camInfo = await this.getCamera();  
      if (camInfo) {
        this.props.handleChangeVideoAllowed(true)
        this.setState({ camAllowed: true })
      }      
    } 
    catch (error) { 
      console.log('Failed camInfo to getUserMedia API:', error)
    }    

    try {
      const audioInfo = await this.getMicrophone();
      if (audioInfo) {
        this.props.actions.setAudioAllowed(true)
        this.setState({ audioAllowed: true })
      }  
    } 
    catch (error) { 
      console.log('Failed audioInfo to getUserMedia API:', error)
    }
  
  }   
  
  async getMicrophone() {
    if (this.audioStream) {
        return this.audioStream;
    }
    return this.audioStream = await navigator.mediaDevices.getUserMedia({audio: true, video: false});
  } 
  
  async getCamera() {
    if (this.videoStream) {
      return this.videoStream;
    }
    return this.videoStream = await navigator.mediaDevices.getUserMedia({audio: false, video: true});
  }   

  handleClickSoundListItem = (event: React.MouseEvent<HTMLElement>) => {
    const { audioAllowed } = this.state;
    if(audioAllowed) {
      this.setState({ soundMenuAnchor: event.currentTarget });
    } else {
      this.setState({
        allowMicrophoneButtonEl: event.currentTarget
      });
    }
  };

  handleSoundMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
    this.setState({ selectedSoundMenuIndex: index, soundMenuAnchor: null  });
    if(index === 1) {
      this.props.handleMuteAudio()
    } else {
      this.props.handleUnMuteAudio()
    }
  };

  handleSoundMenuClose = () => {
    this.setState({ soundMenuAnchor: null });
  };  

  handleClickCamListItem = (event: React.MouseEvent<HTMLElement>) => {
    const { camAllowed } = this.state;
    if(camAllowed) {
      this.setState({ camMenuAnchor: event.currentTarget });
    } else {
      this.setState({
        allowCamButtonEl: event.currentTarget
      });
    }
  };

  handleCamMenuItemClick = (event: React.MouseEvent<HTMLElement>, index: number) => {
    if(index === 0 && this.props.setSelectedCamMenuItem === 0) {
      this.props.handleChangeSourceSelected(index)
    } else if (index === 1 && this.props.setSelectedCamMenuItem === 'screenCam') {
      this.props.handleChangeSourceSelected(index)
    }
    this.setState({ selectedCamMenuIndex: index, camMenuAnchor: null  });
  };

  handleCamMenuClose = () => {
    this.setState({ camMenuAnchor: null });
  };      

  handleCloseAllowMicrophone = () => {
    this.setState({
      allowMicrophoneButtonEl: null
    });
  }  

  handleCloseAllowCamera = () => {
    this.setState({
      allowCamButtonEl: null
    });
  }   

  renderAllowMicrophonePopover() {
    const { classes } = this.props;
    const { allowMicrophoneButtonEl } = this.state;
    return (
      <Popover
        id="allowMicrophonePermisisions-popper"
        open={Boolean(allowMicrophoneButtonEl)}
        anchorEl={allowMicrophoneButtonEl}
        onClose={this.handleCloseAllowMicrophone}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Typography className={classes.typography}>Enable Microphone permissions in your browser</Typography>
      </Popover>
    );
  }

  renderAllowCameraPopover() {
    const { classes } = this.props;
    const { allowCamButtonEl } = this.state;
    return (
      <Popover
        id="allowCamPermisisions-popper"
        open={Boolean(allowCamButtonEl)}
        anchorEl={allowCamButtonEl}
        onClose={this.handleCloseAllowCamera}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Typography className={classes.typography}>Enable Camera permissions in your browser</Typography>
      </Popover>
    );
  }  

  render() {
    const { classes } = this.props;
    const { soundMenuAnchor, camMenuAnchor, selectedSoundMenuIndex, selectedCamMenuIndex, audioAllowed, camAllowed } = this.state;

    return (  
      <Box my={2}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <List aria-label="Sound settings">
              <ListItem
                button
                aria-haspopup="true"
                aria-controls="sound-menu"
                aria-label="Sound Menu"
                classes={{
                  root: classes.listItemRoot
                }}
                onClick={this.handleClickSoundListItem}
              >
                <ListItemIcon>
                  {optionsSound[selectedSoundMenuIndex] === 'Mic Off' || !audioAllowed ? <MicOffIcon /> : <MicIcon />}
                </ListItemIcon>
                <ListItemText primary={audioAllowed ? optionsSound[selectedSoundMenuIndex] : 'Allow Permissions'} />
                  {soundMenuAnchor ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </ListItem>
            </List>
            {this.renderAllowMicrophonePopover()}
          </Grid>
          <Grid item xs={12} sm={6}>
            <List aria-label="Cam settings"> 
              <ListItem
                button
                aria-haspopup="true"
                aria-controls="cam-menu"
                aria-label="Cam menu"
                classes={{
                  root: classes.listItemRoot
                }}
                onClick={this.handleClickCamListItem}
              >
                <ListItemIcon>
                  {optionsCam[selectedCamMenuIndex] === 'Camera Off' || !camAllowed ? <VideocamOffIcon /> : <VideocamIcon />}
                </ListItemIcon>
                <ListItemText primary={camAllowed ? optionsCam[selectedCamMenuIndex] : 'Allow Permissions'} />
                {camMenuAnchor ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </ListItem>
            </List>
            {this.renderAllowCameraPopover()}
          </Grid>
        </Grid>
        <Menu
          id="sound-menu"
          anchorEl={soundMenuAnchor}
          keepMounted
          open={Boolean(soundMenuAnchor)}
          onClose={this.handleSoundMenuClose}
        >
          {optionsSound.map((option, index) => (
            <MenuItem
              key={option}
              selected={index === selectedSoundMenuIndex}
              onClick={(event) => this.handleSoundMenuItemClick(event, index)}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
        <Menu
          id="cam-menu"
          anchorEl={camMenuAnchor}
          keepMounted
          open={Boolean(camMenuAnchor)}
          onClose={this.handleCamMenuClose}
        >
          {optionsCam.map((option, index) => (
            <MenuItem
              key={option}
              disabled={(this.props.setSelectedCamMenuItem === 'cam' && index === 1) || (this.props.setSelectedCamMenuItem === 1 && index === 0) ? true : false}
              selected={index === selectedCamMenuIndex}
              onClick={(event) => this.handleCamMenuItemClick(event, index)}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </Box>
    );
  }

  }

  export default withActions((withStyles(styles)(Devices)));
